import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { X } from 'lucide-react';
export function FailedApproaches() {
  const failures = ['Las dietas Keto constantes apagan tu tiroides y destruyen tu energía a largo plazo.', 'Las rutinas de gimnasio intensas elevan tu cortisol, ensanchando tu cintura en lugar de reducirla.', "Los jugos verdes y 'detox' ignoran la pérdida de masa muscular, que es tu verdadero motor quemagrasa.", 'Contar calorías no funciona porque tu cuerpo no es una calculadora, es un laboratorio químico.'];
  return <section className="py-20 bg-white" data-id="element-13">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <FadeIn data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-serif text-[#1A5C4C] text-center mb-12" data-id="element-16">
            Por qué lo que intentaste no funcionó
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-17">
          {failures.map((item, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-18">
              <div className="flex items-start space-x-4 p-6 bg-[#FDF6F0] rounded-xl" data-id="element-19">
                <div className="flex-shrink-0 mt-1" data-id="element-20">
                  <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center" data-id="element-21">
                    <X className="w-5 h-5 text-red-600" data-id="element-22" />
                  </div>
                </div>
                <p className="text-lg text-[#2A2A2A]" data-id="element-23">{item}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}